import api from "../api/axios";

export const getLoanRequests = async (groupId, status) => {
  const response = await api.get(`/loan-request/${groupId}`, { params: status ? { status } : {} });
  return response.data;
};

export const getLoanRequest = async (id) => {
  const response = await api.get(`/loan-request/single/${id}`);
  return response.data;
};

export const approveLoanRequest = async (id) => {
  const response = await api.post(`/loan-request/${id}/approve`);
  return response.data;
};

export const rejectLoanRequest = async ({ id, reason }) => {
  const response = await api.post(`/loan-request/${id}/reject`, { reason });
  return response.data;
};
